export enum UserRole {
  ADMIN = 'admin',
  SUPPLIER = 'supplier',
  STANDARD = 'standard',
}
